{
  "comment": "GENERATED from game/misc.cpp gaclr24bpp + game/res.h kiclr* by client/tools/gen-palette.mjs — do not hand-edit",
  "colors": [
    { "r": 0, "g": 0, "b": 0, "name": "black" },
    { "r": 252, "g": 252, "b": 252, "name": "white" },
    { "r": 252, "g": 0, "b": 0, "name": "red" },
    { "r": 0, "g": 252, "b": 0, "name": "green" },
    { "r": 252, "g": 252, "b": 0, "name": "yellow" },
    { "r": 0, "g": 116, "b": 232, "name": "side 1 color" },
    { "r": 232, "g": 32, "b": 0, "name": "side 2 color" },
    { "r": 232, "g": 228, "b": 0, "name": "side 3 color" },
    { "r": 104, "g": 252, "b": 252, "name": "side 4 color" },
    { "r": 0, "g": 192, "b": 196, "name": "button fill" },
    { "r": 0, "g": 96, "b": 196, "name": "button border" },
    { "r": 0, "g": 0, "b": 0, "name": "menu background" },
    { "r": 0, "g": 0, "b": 0, "name": "form background" },
    { "r": 28, "g": 56, "b": 59, "name": "mini map border area" },
    { "r": 155, "g": 88, "b": 140, "name": "Galaxite minimap color" },
    { "r": 84, "g": 160, "b": 172, "name": "button fill highlight" },
    { "r": 132, "g": 128, "b": 128, "name": "medium gray" },
    { "r": 0, "g": 116, "b": 232, "name": "blue side 0" },
    { "r": 0, "g": 96, "b": 196, "name": "blue side 1" },
    { "r": 0, "g": 64, "b": 120, "name": "blue side 2" },
    { "r": 0, "g": 48, "b": 92, "name": "blue side 3" },
    { "r": 0, "g": 32, "b": 64, "name": "blue side 4" },
    { "r": 232, "g": 32, "b": 0, "name": "red side 0" },
    { "r": 196, "g": 29, "b": 0, "name": "red side 1" },
    { "r": 120, "g": 8, "b": 0, "name": "red side 2" },
    { "r": 92, "g": 8, "b": 0, "name": "red side 3" },
    { "r": 64, "g": 8, "b": 0, "name": "red side 4" },
    { "r": 232, "g": 228, "b": 0, "name": "yellow side 0" },
    { "r": 196, "g": 192, "b": 0, "name": "yellow side 1" },
    { "r": 120, "g": 116, "b": 0, "name": "yellow side 2" },
    { "r": 92, "g": 88, "b": 0, "name": "yellow side 3" },
    { "r": 64, "g": 60, "b": 0, "name": "yellow side 4" },
    { "r": 104, "g": 252, "b": 252, "name": "cyan side 0" },
    { "r": 84, "g": 160, "b": 172, "name": "cyan side 1" },
    { "r": 56, "g": 120, "b": 131, "name": "cyan side 2" },
    { "r": 40, "g": 80, "b": 88, "name": "cyan side 3" },
    { "r": 28, "g": 56, "b": 59, "name": "cyan side 4" },
    { "r": 16, "g": 40, "b": 43, "name": "list background" },
    { "r": 84, "g": 160, "b": 172, "name": "list border" },
    { "r": 184, "g": 248, "b": 248, "name": "Jana font" },
    { "r": 104, "g": 252, "b": 252, "name": "Andy font" },
    { "r": 232, "g": 228, "b": 0, "name": "Olstrom font" },
    { "r": 232, "g": 32, "b": 0, "name": "Fox font" },
    { "r": 216, "g": 216, "b": 216, "name": "neutral side 0" },
    { "r": 168, "g": 168, "b": 168, "name": "neutral side 1" },
    { "r": 120, "g": 120, "b": 120, "name": "neutral side 2" },
    { "r": 92, "g": 92, "b": 92, "name": "neutral side 3" },
    { "r": 64, "g": 64, "b": 64, "name": "neutral side 4" },
    { "r": 252, "g": 0, "b": 252, "name": "Galaxite fullness indicator/neon pink" }
  ],
  "iclr": {
    "kiclrBlack": 0,
    "kiclrWhite": 1,
    "kiclrRed": 2,
    "kiclrGreen": 3,
    "kiclrYellow": 4,
    "kiclrSide1": 5,
    "kiclrSide2": 6,
    "kiclrSide3": 7,
    "kiclrSide4": 8,
    "kiclrButtonFill": 9,
    "kiclrButtonBorder": 10,
    "kiclrMenuBack": 11,
    "kiclrFormBackground": 12,
    "kiclrMiniMapBorder": 13,
    "kiclrGalaxite": 14,
    "kiclrButtonFillHighlight": 15,
    "kiclrMediumGray": 16,
    "kiclrBlueSideFirst": 17,
    "kiclr0BlueSide": 17,
    "kiclr1BlueSide": 18,
    "kiclr2BlueSide": 19,
    "kiclr3BlueSide": 20,
    "kiclr4BlueSide": 21,
    "kiclrBlueSideLast": 21,
    "kiclrRedSideFirst": 22,
    "kiclr0RedSide": 22,
    "kiclr1RedSide": 23,
    "kiclr2RedSide": 24,
    "kiclr3RedSide": 25,
    "kiclr4RedSide": 26,
    "kiclrRedSideLast": 26,
    "kiclrYellowSideFirst": 27,
    "kiclr0YellowSide": 27,
    "kiclr1YellowSide": 28,
    "kiclr2YellowSide": 29,
    "kiclr3YellowSide": 30,
    "kiclr4YellowSide": 31,
    "kiclrYellowSideLast": 31,
    "kiclrCyanSideFirst": 32,
    "kiclr0CyanSide": 32,
    "kiclr1CyanSide": 33,
    "kiclr2CyanSide": 34,
    "kiclr3CyanSide": 35,
    "kiclr4CyanSide": 36,
    "kiclrCyanSideLast": 36,
    "kiclrListBackground": 37,
    "kiclrListBorder": 38,
    "kiclrJana": 39,
    "kiclrAndy": 40,
    "kiclrOlstrom": 41,
    "kiclrFox": 42,
    "kiclrSideNeutral": 43,
    "kiclrNeutralSideFirst": 43,
    "kiclr0NeutralSide": 43,
    "kiclr1NeutralSide": 44,
    "kiclr2NeutralSide": 45,
    "kiclr3NeutralSide": 46,
    "kiclr4NeutralSide": 47,
    "kiclrNeutralSideLast": 47,
    "kiclrFullnessIndicator": 48
  },
  "gaiclrSide": [43, 5, 6, 7, 8]
}
